import { createSlice } from '@reduxjs/toolkit';
import { engagementInitialState } from './engagement-initial-state';

const engagementViewSlice = createSlice({
  name: 'engagementView',
  initialState: engagementInitialState,
  reducers: {
    setAllInformation: (state, action) => {
      state.allInformation = action.payload;
    },
  },
});

export const { setAllInformation } = engagementViewSlice.actions;
export default engagementViewSlice.reducer;
